// extracted by mini-css-extract-plugin
export default {"item":"Building-module--item--109d6","image":"Building-module--image--e0f2f","content":"Building-module--content--16b3f","cta":"Building-module--cta--c81ee"};